<template>
  <div class="about">
    <h1>About</h1>
    Doc-Alert is a quick, lightweight and innovative method to direct and manage patient care when and where it is needed.
    <hr />
    <Privacy />
  </div>
</template>

<style scoped>
body {margin:10px;padding:10px}
</style>

<script>
import Privacy from '@/components/core/privacy.vue'
export default {
  name: 'DirectoryAdmin',
  components: {
    Privacy
  }
}
</script>
